(ns frontend.ui.component.lp-portal.report.body.real-estate.fund.nre.controller.overview
  (:require [common.util :as cu]
            [frontend.ui.component.chart.utils :as chart-utils]
            [frontend.ui.component.lp-portal.donut-chart.view :as donut-chart]
            [frontend.ui.component.lp-portal.report.controller :as report-ctl]
            [frontend.ui.component.lp-portal.report.overview.big-figures.controller :as big-figures]
            [frontend.ui.page.lp-portal.report.util :as util]
            [frontend.ui.style.theme.core :as theme]
            [frontend.ui.style.theme.core :refer [color]]))

(defn- ->overview-figures
  [fund-figures]
  [[(util/->multiple (last (:gross-equity-multiple fund-figures))) "Gross multiple"]
   [(util/->multiple (last (:net-multiple fund-figures))) "Net multiple"]
   [(util/->percent-1-decimal (last (:gross-equity-irr fund-figures))) "Gross IRR"]
   [(util/->percent-1-decimal (last (:net-irr fund-figures))) "Net IRR"]])

(defn- ->historical-net-cash-flows-to-investors
  [{:keys [labels
           semiannual-capital-calls
           semiannual-distributions
           cumulative-net-cash-to-investors
           cumulative-capital-calls]}]
  ;; FIXME check/ask what the dimension of these values are (pct, int, ???) and apply
  (let [semiannual-capital-calls (map #(* 100 %) semiannual-capital-calls)
        semiannual-distributions (map #(* 100 %) semiannual-distributions)
        cumulative-net-cash-to-investors (map #(* 100 %) cumulative-net-cash-to-investors)
        cumulative-capital-calls (map #(* 100 %) cumulative-capital-calls)]
    {:chart       {:zoomType "xy"}
     :colors      [(theme/color [:lp-report :chart :bar-1])
                   (theme/color [:lp-report :chart :bar-2])
                   (theme/color [:lp-report :chart :line-1])
                   (theme/color [:lp-report :chart :line-2])]
     :xAxis       [{:categories    labels
                    :crosshair     true
                    :lineColor     (theme/color [:chart :x-axis :line])
                    :gridLineColor (theme/color [:chart :x-axis :grid-line])}]
     :yAxis       [{:labels        {:format "{value}%"}
                    :title         {:text nil}
                    :lineColor     (theme/color [:chart :y-axis :line])
                    :gridLineColor (theme/color [:chart :y-axis :grid-line])}]
     :tooltip     {:outside         true
                   :useHtml         true
                   :backgroundColor (theme/color [:page-bg :bg])
                   :style           {:opacity         1
                                     :backgroundColor (theme/color [:page-bg :bg])}

                   :shared          true}
     :plotOptions {:line {:marker {:enabled false}}}
     :series      [{:name    "Quarterly capital calls % of fund size"
                    :type    "column"
                    :data    semiannual-capital-calls
                    :tooltip {:outside         true
                              :useHtml         true
                              :backgroundColor (theme/color [:page-bg :bg])
                              :style           {:opacity         1
                                                :backgroundColor (theme/color [:page-bg :bg])}
                              :pointFormatter  chart-utils/pct-formatter}
                    ;:tooltip {:valueSuffix "%"}
                    }
                   {:name    "Quarterly distributions % of fund size"
                    :type    "column"
                    :data    semiannual-distributions
                    :tooltip {:outside         true
                              :useHtml         true
                              :backgroundColor (theme/color [:page-bg :bg])
                              :style           {:opacity         1
                                                :backgroundColor (theme/color [:page-bg :bg])}
                              :pointFormatter  chart-utils/pct-formatter}
                    ;:tooltip {:valueSuffix "%"}
                    }
                   {:name    "Cumulative net cash flow to investors % of fund size"
                    :type    "line"
                    :data    cumulative-net-cash-to-investors
                    :tooltip {:outside         true
                              :useHtml         true
                              :backgroundColor (theme/color [:page-bg :bg])
                              :style           {:opacity         1
                                                :backgroundColor (theme/color [:page-bg :bg])}
                              :pointFormatter  chart-utils/pct-formatter}
                    ;:tooltip {:valueSuffix "%"}
                    }
                   {:name    "Cumulative capital calls % of fund size"
                    :type    "line"
                    :data    cumulative-capital-calls
                    :tooltip {:outside         true
                              :useHtml         true
                              :backgroundColor (theme/color [:page-bg :bg])
                              :style           {:opacity         1
                                                :backgroundColor (theme/color [:page-bg :bg])}
                              :pointFormatter  chart-utils/pct-formatter}
                    ;:tooltip {:valueSuffix "%"}
                    }]}))

(defn- ->total-investment
  [{:keys [labels cumulative-equity-at-cost]}]
  (let [datas (->> (map (fn [l v] [l v]) labels cumulative-equity-at-cost)
                   (cu/remove-by first "Exits")
                   (sort-by (fn [[l v]]
                              (if (= l "Exits")
                                -10000
                                v)))
                   (reverse))
        data (->> datas
                  (map second))
        labels (->> datas
                    (map first))]
    {:chart       {:type :bar}
     :tooltip     {:outside         true
                   :useHtml         true
                   :backgroundColor (theme/color [:page-bg :bg])
                   :style           {:opacity         1
                                     :backgroundColor (theme/color [:page-bg :bg])}
                   :enabled         false}
     :plotOptions {:series {:colorByPoint true
                            :dataLabels   {:style     {:color       "contrast"
                                                       :textOutline false}
                                           :enabled   true
                                           :formatter (fn [arg]
                                                        (this-as
                                                         js-data-point
                                                          (let [point (js->clj js-data-point
                                                                               :keywordize-keys
                                                                               true)]
                                                            (str (util/->int-million (:y point))
                                                                 " M€"))))}}}
     :colors      (or (util/gradient-colors [:lp-report :chart :bar :gradient-start]
                                            [:lp-report :chart :bar :gradient-start]
                                            (count data)))
     :legend      {:enabled false}
     :xAxis       {:categories    labels
                   :lineColor     (theme/color [:chart :x-axis :line])
                   :gridLineColor (theme/color [:chart :x-axis :grid-line])}
     :yAxis       {:visible       false
                   ;; TODO: if largest value differs from smallest value more that 99% -> use logarithmic
                   ;:type    "logarithmic"
                   :lineColor     (theme/color [:chart :y-axis :line])
                   :gridLineColor (theme/color [:chart :y-axis :grid-line])}
     :series      [{:name "Current equity at cost"
                    :data data}]}))

(defn ->net-asset-value
  [{:keys [labels nav]}]
  (let [datas (->> (map (fn [l v] [l v]) labels nav)
                   (sort-by second)
                   (reverse))
        data (->> datas
                  (map second))
        labels (->> datas
                    (map first))]
    {:chart       {:type :bar}
     :tooltip     {:outside         true
                   :useHtml         true
                   :backgroundColor (theme/color [:page-bg :bg])
                   :style           {:opacity         1
                                     :backgroundColor (theme/color [:page-bg :bg])}
                   :enabled         false}
     :plotOptions {:series {:colorByPoint true
                            :dataLabels   {:style     {:color       "contrast"
                                                       :textOutline false}
                                           :enabled   true
                                           :formatter (fn [arg]
                                                        (this-as
                                                         js-data-point
                                                          (let [point (js->clj js-data-point
                                                                               :keywordize-keys
                                                                               true)]
                                                            (str (util/->int-million (:y point))
                                                                 " M€"))))}}}
     :colors      (or (util/gradient-colors [:lp-report :chart :bar :gradient-start]
                                            [:lp-report :chart :bar :gradient-start]
                                            (count data)))
     :legend      {:enabled false}
     :xAxis       {:categories    labels
                   :lineColor     (theme/color [:chart :x-axis :line])
                   :gridLineColor (theme/color [:chart :x-axis :grid-line])}
     :yAxis       {:visible       false
                   :lineColor     (theme/color [:chart :y-axis :line])
                   :gridLineColor (theme/color [:chart :y-axis :grid-line])}
     :series      [{:data data}]}))

(defn sector-allocation-nav
  [sector-allocation]
  (when-let [data (seq (util/->array-of-tuples sector-allocation :nav))]
    (donut-chart/donut-chart-config data
                                    {:data-label-formatter
                                     chart-utils/pie-me-label-formatter-no-division})))

(defn sector-allocation-gav
  [sector-allocation]
  (when-let [data (seq (util/->array-of-tuples sector-allocation :gav))]
    (donut-chart/donut-chart-config data
                                    {:data-label-formatter
                                     chart-utils/pie-me-label-formatter-no-division})))

(defn country-allocation-nav
  [country-allocation]
  (when-let [data (seq (util/->array-of-tuples country-allocation :nav))]
    (donut-chart/donut-chart-config data
                                    {:data-label-formatter
                                     chart-utils/pie-me-label-formatter-no-division})))

(defn country-allocation-gav
  [country-allocation]
  (when-let [data (seq (util/->array-of-tuples country-allocation :gav))]
    (donut-chart/donut-chart-config data
                                    {:data-label-formatter
                                     chart-utils/pie-me-label-formatter-no-division})))

(defn ->overview
  [{:keys [dynamic-path dynamic-data report-data map-topo] :as props}]
  {:overview-figures        (report-ctl/with-footnote
                             props
                             :overview-figures-footnotes
                             (big-figures/summary-figures report-data))
   :recent-development-text (report-ctl/rich-content props :recent-development-text)
   :highlights              (report-ctl/with-footnote props
                                                      :highlight-footnotes
                                                      (get-in report-data
                                                              [:fund-figures]))
   :historical-net-cash-flows-to-investors
   (report-ctl/with-footnote props
                             :historical-net-cash-flows-to-investors-footnotes
                             (->historical-net-cash-flows-to-investors
                              (get-in report-data [:chart-data-net-cash-flows])))
   :total-investment
   (report-ctl/with-footnote props
                             :total-investment-footnotes
                             (->total-investment (get-in report-data
                                                         [:chart-data-total-investment])))
   :net-asset-value
   (report-ctl/with-footnote props
                             :net-asset-value-footnotes
                             (->net-asset-value (get-in report-data [:chart-data-nav])))
   :sector-allocation-nav
   (report-ctl/with-footnote props
                             :sector-allocation-nav-footnotes
                             (sector-allocation-nav (get-in report-data [:chart-data-sector-allocation])))
   :sector-allocation-gav
   (report-ctl/with-footnote props
                             :sector-allocation-gav-footnotes
                             (sector-allocation-gav (get-in report-data [:chart-data-sector-allocation])))
   :country-allocation-nav
   (report-ctl/with-footnote props
                             :country-allocation-nav-footnotes
                             (country-allocation-nav (get-in report-data [:chart-data-country-allocation])))
   :country-allocation-gav
   (report-ctl/with-footnote props
                             :country-allocation-gav-footnotes
                             (country-allocation-gav (get-in report-data [:chart-data-country-allocation])))})
